import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import RestoreIcon from "@material-ui/icons/Restore";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import Loader from "components/Loader";
import { transformViewDate } from "utils/date-utils";
import { getPersonFullName } from "utils/person";
import { useRacehorse360Api } from "hooks/api";
import { getExamNoteCreatorName } from "../helper";

import useStyles from "./styles";

const LastExamNotesModal = props => {
  const { horse } = props;
  const classes = useStyles();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { useListHorseExams } = useRacehorse360Api();

  const { isLoading: isExamsLoading, data: examsData } = useListHorseExams(
    {
      query: {
        horseIds: [horse.id],
        statuses: [racehorse360.HorseExamStatus.HORSE_EXAM_STATUS_COMPLETED],
        horseExamTypes: [racehorse360.HorseExamType.HORSE_EXAM_TYPE_FULL_EXAM],
        withNoteOnly: true
      },
      getOptions: {
        select: [
          "note",
          "assignedUser.firstName",
          "assignedUser.lastName",
          "completedDate"
        ],
        orderBy: ["completedDate desc"]
      }
    },
    {
      enabled: isModalOpen
    }
  );

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <IconButton
        size={"small"}
        onClick={handleOpen}
        className={classes.historyButton}
      >
        <RestoreIcon className={classes.lastExamsIcon} />
      </IconButton>
      {isModalOpen && (
        <Dialog
          classes={{
            paper: classes.dialogPaper
          }}
          open={isModalOpen}
          onClose={handleClose}
        >
          {isExamsLoading && <Loader overlay />}
          <DialogTitle className={classes.dialogTitle}>
            Exam Note History
            <IconButton
              color="primary"
              onClick={handleClose}
              size={"small"}
              classes={{
                root: classes.dialogCloseButton
              }}
            >
              <CloseIcon className={classes.dialogCloseButtonIcon} />
            </IconButton>
          </DialogTitle>
          <DialogContent className={classes.examNotesContainer}>
            <div className={classes.examNotesContainerHeader}>
              <div className={classes.horseName}>
                {horse.name.toUpperCase()}
              </div>
              <div className={classes.trainerName}>
                {getPersonFullName(horse.trainer)}
              </div>
            </div>
            {!isExamsLoading &&
              examsData.horseExams.slice(0, 5).map(horseExam => {
                const { id, assignedUser, completedDate, note } = horseExam;
                return (
                  <div className={classes.examNotesListItem} key={id}>
                    <div>
                      <span className={classes.commentCreator}>
                        {`${getExamNoteCreatorName(assignedUser)} `}
                      </span>
                      <span className={classes.createDateTime}>
                        {transformViewDate(
                          completedDate,
                          null,
                          "MM/dd/yy h:mm a"
                        )}
                      </span>
                    </div>
                    <div className={classes.examNotesContainerBody}>{note}</div>
                  </div>
                );
              })}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default LastExamNotesModal;
